import { axiosSwagger } from "@/axios";



export const state = {
  // move file to folder
  moveFileToFolder: {
    loading: false,
  }
}


export const getters = {
}


export const mutations = {
  // MOVE FILE TO FOLDER
  moveFileToFolderLoading: (state, loading) => {
    state.moveFileToFolder.loading = loading;
  },
}


export const actions = {
  // MOVE FILE TO FOLDER
  async moveFileToFolder({ commit }, data) {
    commit("moveFileToFolderLoading", true);

    return await axiosSwagger
      .put(`/api/FileManager/Move/${data.fileFolderId}`, data.moveFileIds)
      .then((response) => {
        commit("moveFileToFolderLoading", false);

        return response;
      })
      .catch(() => {
        commit("moveFileToFolderLoading", false);
      });
  },
}

